module.exports = __webpack_public_path__ + "static/media/im7.8363d33c.png";